import React from "react";
import * as styles from "./SectionTitle.module.scss"

const SectionTitle = ({text}) => {
    return(<h2 className={styles.container}>{text}</h2>)
}
export default SectionTitle;